module.exports = __webpack_public_path__ + "static/img/api_01.40f231a8.svg";